import CarrierOption from '../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/carrier';
import CreatedDateOption from '../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/created-date';
import InsuranceOption from '../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/insurance';
import InsuranceFeeOption from '../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/insurance-fee';
import OrderNumberOption from '../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/order-number';
import PackageTypeOption from '../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/package-type';
import ServiceOption from '../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/service';

import { UniqueOptions } from './unique-options';

const uniqueOptionsThatArePopular = ['returnsShipTo', 'provider'];
const receivedDateId = 'receivedDate';

export const popularFilterByOptions = UniqueOptions.filter((option) => uniqueOptionsThatArePopular.indexOf(option.id) !== -1);

export const otherFilterByOptionsReceivedView = [
  CarrierOption,
  ...UniqueOptions.filter((option) => uniqueOptionsThatArePopular.indexOf(option.id) === -1),
  { ...CreatedDateOption, actionableFilterPill: undefined },
  InsuranceOption,
  InsuranceFeeOption,
  OrderNumberOption,
  PackageTypeOption,
  ServiceOption,
];

export const otherFilterByOptions = [...otherFilterByOptionsReceivedView.filter((option) => option.id !== receivedDateId)];
